import { handleActions } from 'redux-actions';

export default handleActions(
	{
		FETCH_SONG_FULFILLED: (state, action) => ({
			...state,

			list: action.payload.list,

			data: {
				...state.data,
				...action.payload.data,
			},

			limit: action.payload.limit,
			offset: action.payload.offset,
		}),

		UPDATE_SONG_KEYWORD: (state, action) => ({
			...state,

			keyword: action.payload.value,
		}),

		FETCH_USER_FULFILLED: (state, action) => ({
			...state,

			data: {
				...state.data,
				...action.payload.songData,
			},
		}),
	},
	{
		list: [],
		data: {},
		limit: 10,
		offset: 0,
		keyword: '',
	},
);



// WEBPACK FOOTER //
// ./src/reducers/song.js